import React from 'react';
import { RouteConfig } from './types';

import UiSample        from '@/pages/UiSample';
import Home            from '@/pages/home';
import StudentLogin    from '@/pages/student/auth/login';
import StudentSignUp   from '@/pages/student/auth/sign_up';
import StudentFindId   from '@/pages/student/auth/find_id';
import StudentExamList   from '@/pages/student/exam/list';
import StudentExamPaper from '@/pages/student/exam/paper';
import StudentExamResult from '@/pages/student/exam/result';
import StudentVocabularyList from '@/pages/student/vocabulary/list';
import StudentVocabularyBook from '@/pages/student/vocabulary/book';
import StudentVocabularyLearning from '@/pages/student/vocabulary/wordLearning';
import StudentMypageInfo from '@/pages/student/mypage/info';
import StudentMypageHomework from '@/pages/student/mypage/homework/homework';
import StudentMypageHomeworkDetail from '@/pages/student/mypage/homework/detail';
import StudentMypageExamList from '@/pages/student/mypage/exam/list';
import StudentMypageExamDetail from '@/pages/student/mypage/exam/detail';
import StudentLearningList from '@/pages/student/learning/list';
import StudentLearningDetail from '@/pages/student/learning/detail';
import StudentMypageAchievements from '@/pages/student/mypage/achievements';
import StudentLeaning from '@/pages/student/learning/doing';
import StudentHomeworkList from '@/pages/student/homework/list';
import StudentHomeworkDetail from '@/pages/student/homework/detail';
import PublicReport from '@/pages/public/report';

export const studentRoutes: RouteConfig[] = [
  {
    path: '/playground',
    name: 'UI Sample',
    element: <UiSample />,
    background: 'gradient',
  },
  // slug 루트 홈 (공개)
  {
    path: '/:slug',
    name: '홈(slug)',
    element: <Home />,
    background: 'gradient',
    containerProps: { size: 'max', paddingX: 'none' },
  },
  // slug 로그인/회원/아이디 찾기 (공개)
  {
    path: '/:slug/login',
    name: '학생 로그인(slug)',
    element: <StudentLogin />,
    background: 'gradient',
    containerProps: { size: 'sm' },
  },
  // {
  //   path: '/:slug/sign_up',
  //   name: '학생 회원가입(slug)',
  //   element: <StudentSignUp />,
  //   background: 'gradient',
  //   containerProps: { size: 'sm' },
  // },
  {
    path: '/:slug/find_id',
    name: '학생 아이디 찾기(slug)',
    element: <StudentFindId />,
    background: 'gradient',
    containerProps: { size: 'sm' },
  },
  // 공개 페이지 (로그인 불필요)
  {
    path: '/report/:token',
    name: '공유 성적표',
    element: <PublicReport />,
    background: 'solid',
    hideHeader: true,
    hideFooter: true,
  },
  // 공개 페이지 (slug 포함 경로 지원)
  {
    path: '/:slug/report/:token',
    name: '공유 성적표(slug)',
    element: <PublicReport />,
    background: 'solid',
    hideHeader: true,
    hideFooter: true,
  },
  // 학생
  {
    path: '/',
    name: '홈',
    element: <Home />,
    background: 'gradient',
    containerProps: { size: 'max', paddingX: 'none' },
  },
  {
    path: '/login',
    name: '학생 로그인 ✅',
    element: <StudentLogin />,
    background: 'gradient',
    containerProps: { size: 'sm' },
  },
  // {
  //   path: '/sign_up',
  //   name: '학생 회원가입 ✅',
  //   element: <StudentSignUp />,
  //   background: 'gradient',
  //   containerProps: { size: 'sm' },
  // },
  {
    path: '/find_id',
    name: '학생 아이디 찾기 ✅', 
    element: <StudentFindId />,
    background: 'gradient',
    containerProps: { size: 'sm' },
  },
  {
    path: '/exam/list',
    name: '시험지 ✅', 
    element: <StudentExamList />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/exam/paper',
    name: '시험지 ✅', 
    element: <StudentExamPaper />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/exam/result',
    name: '시험지 결과 ✅', 
    element: <StudentExamResult />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/vocabulary/list',
    name: '단어장 리스트 ✅', 
    element: <StudentVocabularyList />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/vocabulary/book',
    name: '단어장 리스트 ✅', 
    element: <StudentVocabularyBook />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/vocabulary/detail',
    name: '단어장 학습 ✅', 
    element: <StudentVocabularyLearning />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/mypage/info',
    name: '마이페이지 기본정보 ✅', 
    element: <StudentMypageInfo />,
    background: 'gradient',
    containerProps: { size: 'md' },
  },
  {
    path: '/mypage/homework',
    name: '마이페이지 숙제 채점표✅', 
    element: <StudentMypageHomework />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/mypage/homework/detail',
    name: '마이페이지 숙제 채점표 상세✅', 
    element: <StudentMypageHomeworkDetail />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/mypage/exam',
    name: '마이페이지 시험 ✅', 
    element: <StudentMypageExamList />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: '/mypage/exam/detail',
    name: '마이페이지 시험 상세 ✅', 
    element: <StudentMypageExamDetail />,
    background: 'gradient',
    containerProps: { size: 'xl', paddingX: 'none' },
  },
  {
    path: 'mypage/trophy_badge',
    name: '마이페이지 트로피 및 뱃지 ✅', 
    element: <StudentMypageAchievements />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: 'learning/doing',
    name: '학습/숙제 하기 (수정 필요)', 
    element: <StudentLeaning />,
    background: 'gradient',
    containerProps: { size: 'md' },
  },
  {
    path: 'learning/list',
    name: '학습/리스트✅', 
    element: <StudentLearningList />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: 'learning/detail/:id',
    name: '학습/상세✅ ', 
    element: <StudentLearningDetail />,
    background: 'gradient',
    containerProps: { size: 'md' },
  },
  {
    path: 'homework/list',
    name: '숙제/리스트✅', 
    element: <StudentHomeworkList />,
    background: 'gradient',
    containerProps: { size: 'xl' },
  },
  {
    path: 'homework/detail/:id',
    name: '숙제/상세✅', 
    element: <StudentHomeworkDetail />,
    background: 'gradient',
    containerProps: { size: 'md' },
  },
  {
    path: 'homework/doing',
    name: '숙제/하기✅', 
    element: <StudentLeaning />,
    background: 'gradient',
    containerProps: { size: 'md' },
  },
];

